import { useState, useEffect } from "react";
import Card from "../UI/Card";
import classes from "./ToonBestelling.module.css";

const ToonBestelling = () => {
  //const [gegevens, setGegevens] = useState([]);
  const [bestellingen, setBestellingen] = useState([]);
  //const id = 223;
  //const id = 232;
  /*
  let i, len, lijstmetids;
  for (i = 0, len = bestellingen.length, lijstmetids = []; i < len; i++) {
    //text += bestellingen[i].idpersonalia + "<br/>";
    lijstmetids.push(bestellingen[i].idpersonalia);
  }
  console.table(lijstmetids);

  useEffect(() => {
    const fetchGegevens = async () => {
      const response = await fetch(
        `https://www.marchouben.nl/php/personalia-get.php?id=${id}`
      );

      if (!response.ok) {
        throw new Error("Something went wrong!");
      }

      const responseData = await response.json();
      console.log(responseData);
      setGegevens(responseData);
    };

    fetchGegevens().catch((error) => {
      console.log(error.message);
    });
  }, []);

  let gegevensList;

  if (!gegevens) {
    gegevensList = <li>Geen record gevonden</li>;
  } else {
    gegevensList = gegevens.map((gegeven) => (
      <li key={gegeven.id}>
        Voornaam: {gegeven.voornaam} <br /> Achternaam: {gegeven.achternaam}{" "}
        <br />
        Straat: {gegeven.straat} <br /> Huisnummer: {gegeven.huisnummer} <br />
        Postcode: {gegeven.postcode} <br /> Woonplaats: {gegeven.woonplaats}
      </li>
    ));
  }
*/
  useEffect(() => {
    const fetchBestelling = async () => {
      const response = await fetch(
        //`https://www.marchouben.nl/php/javascript-get.php?idpersonalia=${id}`
        `https://www.marchouben.nl/php/javascript-get.php`
      );

      if (!response.ok) {
        throw new Error("Something went wrong!");
      }

      const responseData = await response.json();
      console.log("javascript-get: responseData");
      console.log(responseData);
      setBestellingen(responseData);
    };

    fetchBestelling().catch((error) => {
      console.log(error.message);
    });
  }, []);

  let bestellingList;

  if (!bestellingen) {
    bestellingList = <li>Geen record gevonden</li>;
  } else {
    bestellingList = bestellingen.map((bestelling) => {
      let jsoninhoud = bestelling.json.map((item) => (
        <div key={item.id}>
          Product: {item.naam} <br />
          Aantal: {item.aankoophoeveelheid} <br />
          Prijs: {item.aankoopprijs} <br />
        </div>
      ));

      console.log("jsoninhoud");
      console.log(jsoninhoud);

      return (
        <li key={bestelling.id}>
          Voornaam: {bestelling.voornaam} <br />
          Achternaam: {bestelling.achternaam} <br />
          Straat: {bestelling.straat} <br />
          Huisnummer: {bestelling.huisnummer} <br />
          Postcode: {bestelling.postcode} <br />
          Woonplaats: {bestelling.woonplaats} <br />
          Email: {bestelling.email} <br />
          {jsoninhoud}
          Totaalbedrag: {bestelling.totaalbedrag} <br />
          <span>-----------------------------</span>
        </li>
      );
    });
  }

  // <ul>{gegevensList}</ul>
  return (
    <Card className={classes.bestelling}>
      <ul>{bestellingList}</ul>
    </Card>
  );
};

export default ToonBestelling;
